// @flow
import React from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';

import { searchFlights } from '../../../redux/actions/FlightsUiActions';

type Props = {
  searching: boolean,
  history: {
    push: (str: string) => void,
  },
  location: { search: string },
  query: {
    trip_type: 'R' | 'O',
    departure_date: string,
    arrival_date: string,
    from_location: string,
    to_location: string,
    num_adults: number,
    num_children: number,
    nationality: string,
  },
};

const SearchButtonWithRouter = (props: Props) => {
  const {
    history,
    location: { search, pathname },
    query,
    searching,
    searchFlights,
  } = props;

  const handleClick = () => {
    const str = queryString.stringify(query);
    // Search Flights even if search params is the same
    if (str === search.substring(1)) return searchFlights({ ...query });
    history.push({ pathname, search: `?${str}` });
    // history.push(`/flights?${str}`);
  };

  return (
    <Button color="yellow" onClick={handleClick} className={searching ? 'btn-loading' : ''}>
      {searching ? 'SEARCHING...' : 'SEARCH FLIGHT'}
    </Button>
  );
};

const mapStateToProps = ({ flightsUi: { searchParams } }) => {
  return {
    query: {
      trip_type: searchParams.trip_type,
      departure_date: searchParams.departure_date,
      arrival_date: searchParams.arrival_date,
      from_location: searchParams.from_location,
      to_location: searchParams.to_location,
      num_adults: searchParams.num_adults,
      num_children: searchParams.num_children,
      nationality: searchParams.nationality,
    },
    searching: searchParams.searching,
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    { searchFlights }
  )(SearchButtonWithRouter)
);



// WEBPACK FOOTER //
// ./src/components/Flights/SearchInput/SearchButtonWithRouter.jsx